import {h, Fragment} from "preact"
import { useFacets, useProductFilters } from "@nosto/preact"
import { useEffect, useState, useRef } from "preact/hooks"

import Facet from "./Facet"
import RangeSelector from "./RangeSelector"

export default function SideBar() {
    const { facets } = useFacets()
    const { filters, removeAll } = useProductFilters()
    const [ sidebarOpen, setSidebarOpen ] = useState(false);
    const sidebarRef = useRef(null);

    useEffect(() => {
        document.body.style.overflow = (sidebarOpen && window.innerWidth < 768) ? "hidden" : "";
        
        if(sidebarRef.current && !sidebarOpen) { // prevent aria-hidden errors
            sidebarRef.current.querySelectorAll('*').forEach(el => el.blur());
            sidebarRef.current.blur();
        }

        return () => document.body.style.overflow = "";
    }, [ sidebarOpen, sidebarRef ])

    const openSidebar = () =>{
        setSidebarOpen(true)
    }

    const closeSidebar = () => {
        setSidebarOpen(false)
    }

    return (
        <div class="ns-sidebar-wrapper">
            <button
                type="button"
                class="button--pill flex items-center gap-1"
                aria-controls="ns-sidebar"
                aria-haspopup="dialog"
                onClick={openSidebar}
            >
                <svg xmlns="http://www.w3.org/2000/svg" width="14px" height="14px" viewBox="0 0 24 24" fill="none" role="presentation" aria-hidden="true" focusable="false">
                    <path d="M18.48 18.5368H21M4.68 12L3 12.044M4.68 12C4.68 13.3255 5.75451 14.4 7.08 14.4C8.40548 14.4 9.48 13.3255 9.48 12C9.48 10.6745 8.40548 9.6 7.08 9.6C5.75451 9.6 4.68 10.6745 4.68 12ZM10.169 12.0441H21M12.801 5.55124L3 5.55124M21 5.55124H18.48M3 18.5368H12.801M17.88 18.6C17.88 19.9255 16.8055 21 15.48 21C14.1545 21 13.08 19.9255 13.08 18.6C13.08 17.2745 14.1545 16.2 15.48 16.2C16.8055 16.2 17.88 17.2745 17.88 18.6ZM17.88 5.4C17.88 6.72548 16.8055 7.8 15.48 7.8C14.1545 7.8 13.08 6.72548 13.08 5.4C13.08 4.07452 14.1545 3 15.48 3C16.8055 3 17.88 4.07452 17.88 5.4Z" stroke="#000" stroke-width="1.5" stroke-linecap="round"/>
                </svg>
                <span>Filter By</span>
            </button>

            <div
                id="ns-sidebar"
                class="ns-sidebar fixed bottom-0 h-3/4 mb-0 min-w-full bg-cream-50 w-full rounded-tl-3xl rounded-tr-3xl p-4 left-0"
                aria-role="dialog"
                aria-modal="true"
                aria-labelledby="ns-sidebar-heading"
                aria-hidden={!sidebarOpen}
                ref={sidebarRef}
            >
                <button 
                    type="button"
                    class="ns-sidebar-close absolute bg-cream-50 p-2"
                    onClick={closeSidebar}
                >
                    <svg viewBox="0 0 26 26" aria-hidden="true" focusable="false" role="presentation" class="icon icon-close" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path stroke="#2A2829" stroke-linecap="round" stroke-linejoin="round" stroke-width="2.02152" d="M 20.499 5.501 L 5.5 20.499 M 5.502 5.501 L 20.5 20.499"></path>
                    </svg>
                    <span class="sr-only visually-hidden">Close filter panel</span>
                </button>
                <div class="ns-sidebar-header flex items-center justify-between pr-5">
                    <h2 id="ns-sidebar-heading" class="h2">Filter</h2>
                    <button 
                        type="button" 
                        class="ns-clear-filters underline" 
                        aria-label="Clear all filters"
                        onClick={removeAll}
                        disabled={filters.length < 1}
                    >
                        Clear All
                    </button>
                </div>
                <div class="ns-sidebar-menu h-full">
                    <form 
                        class="flex justify-between flex-col h-full"
                        onSubmit={e => { e.preventDefault() }}
                    >
                        <div class="ns-facet-list">
                            {facets?.map(facet => {
                                switch (facet.type) {
                                    case "terms":
                                        return <Facet key={facet.id} facet={facet} />
                                    case "stats":
                                        return <RangeSelector key={facet.id} facet={facet} />
                                    default:
                                        return null
                                }
                            })}
                        </div>
                        <button 
                            type="submit"
                            class="ns-sidebar-apply button mb-14 mt-3 text-uppercase"
                            onClick={closeSidebar}
                        >
                            Apply Filter(s)
                        </button>
                    </form>
                </div>
            </div>

            <div
                class="ns-sidebar-backdrop fixed top-0 left-0 min-w-full min-h-full hidden"
                aria-label="Close filters list"
                role="button"
                aria-hidden={window.innerWidth >= 768 || !sidebarOpen}
                onClick={closeSidebar}
            />
        </div>
    )
}
